var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.645 9.382L13.703.61c-.925-.815-2.43-.815-3.35 0L.356 9.38a1.05 1.05 0 00.7 1.836c.25 0 .5-.086.698-.263l.625-.547v7.612C2.379 19.66 3.663 21 5.243 21h13.515c1.605 0 2.864-1.31 2.864-2.981v-7.616l.62.547a1.06 1.06 0 001.491-.09 1.045 1.045 0 00-.088-1.483v.005zm-9.368 9.516H9.728V14.03c0-.336.397-.63.849-.63h2.855c.452 0 .85.294.85.63v4.868h-.005zM19.51 8.7v9.318c0 .495-.33.883-.752.883h-2.37v-4.868c0-1.503-1.326-2.727-2.96-2.727h-2.855c-1.63 0-2.961 1.224-2.961 2.727v4.868h-2.37c-.405 0-.751-.405-.751-.883V8.697c0-.048-.009-.09-.013-.134l7.273-6.384c.123-.108.427-.108.55 0l7.226 6.371a.826.826 0 00-.013.147l-.004.004z",
    fill: "#093545"
  })));
}

export default SvgIconHouse;